var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".flex-container {\n  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6, BB7 */\n  display: -ms-flexbox; /* TWEENER - IE 10 */\n  display: -webkit-flex; /* NEW - Safari 6.1+. iOS 7.1+, BB10 */\n  display: flex; /* NEW, Spec - Firefox, Chrome, Opera */\n\n  justify-content: center;\n  align-items: center;\n\n  width: 400px;\n  height: 200px;\n  background-color: #3498db;\n}\n\n/* Custom column width for 5 equal columns */\n.col-lg-15 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n@media (min-width: 992px) {\n  .col-lg-15 {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n}\n\n/* Add some spacing between stacked columns on mobile */\n@media (max-width: 991.98px) {\n  .col-12 {\n    margin-bottom: 1rem;\n  }\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["merchant", "def_currency", "can_view_account"],
  data: function data() {
    return {
      con_key: null,
      con_secret: null,
      admin: null,
      loading: true,
      dt_revenue_today: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },

      revenue_today: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      dt_revenue_this_month: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      revenue_this_month: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      dt_revenue_this_year: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      revenue_this_year: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      dt_revenue_all_time: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      revenue_all_time: {
        usd: "USD 0.0",
        default_currency: this.def_currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      daily_revenue: [],
      hourly_revenue: [],
      monthly_revenue: [],
      annual_revenue: [],
      dt_daily_reg: null,
      daily_reg: {
        male: 0,
        female: 0
      },
      monthly_reg: {
        male: 0,
        female: 0
      },
      annual_reg: {
        male: 0,
        female: 0
      },
      all_time_reg: {
        male: 0,
        female: 0
      },
      default_currency: "",
      api_token: null,
      services: [],
      merchants: [],
      selected_service: null,
      selected_merchant: null,
      consumer_key: null,
      consumer_secret: null,
      revenue_last_7days: [],
      revenue_last_14days: [],
      revenue_last_30days: [],
      board_data: [],
      applications_per_gateway_data: [],
      applications_per_gateway_encoded_data: [],
      weekly_applications_customers: [],
      monthly_applications_customers: [],
      bi_weekly_applications_customers: [],
      years: [],
      current_user: null,
      current_account_balance: 0,
      banner: null,
      account_id: null,
      currency: null,
      current_selection: null,
      loadingalltime: false,
      account_balances: {}
    };
  },

  mounted: function mounted() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    var c = this.$attrs["isadmin"];
    if (this.$attrs["isadmin"] !== "false") {
      this.admin = true;
    } else {
      this.admin = false;
    }
    this.currency = this.$attrs["def_currency"];
    this.current_user = this.$attrs["current_user"];
    this.current_account_balance = this.$attrs["account_bal"];
    this.banner = this.$attrs["banner"];
    this.account_id = this.$attrs["account_id"];
    this.fetch_merchants();

    $("#7day-title").text(this.formatDate((0, _moment2.default)().subtract(7, "days")) + " - " + this.formatDate((0, _moment2.default)()));

    $("#14day-title").text(this.formatDate((0, _moment2.default)().subtract(14, "days")) + " - " + this.formatDate((0, _moment2.default)()));

    $("#30day-title").text(this.formatDate((0, _moment2.default)().subtract(30, "days")) + " - " + this.formatDate((0, _moment2.default)()));

    this.loading = true;
    if (this.admin) {
      this.fetch_dashboard_data([]);
    } else {
      this.fetch_dashboard_data([this.account_id]);
    }
  },
  created: function created() {},
  methods: {
    formatDate: function formatDate(moment) {
      return moment.format("ddd Do MMMM, YYYY");
    },
    fetch_account_balances: function fetch_account_balances() {
      var _this = this;

      var api_url = "/api/dashboard/admin/fetch-account-balances";
      var params = {
        merchant_id: this.selected_merchant ? this.selected_merchant.id : null
      };

      Vue.axios.post(api_url, params).then(function (response) {
        _this.account_balances = response.data;
      }).catch(function () {
        _this.loading = false;
      }).then(function () {
        _this.loading = false;
      });
    },

    refresh_utility_accounts: function refresh_utility_accounts(value) {
      var _this2 = this;

      var api_url = "/api/accounts/merchant/utility";
      this.selected_merchant = value;
      this.fetch_account_balances();

      this.loading = true;
      this.current_selection = value;
      if (this.selected_merchant == null) {
        this.selected_service = null;
        this.fetch_dashboard_data([]);
        this.emitToBoard();
        this.fetch_gateway_sales({ merchant: this.selected_merchant.id, service_accounts: this.services.map(function (account) {
            return account.id;
          }) });
        return;
      }

      Vue.axios.get(api_url, {
        params: {
          merchant_id: this.selected_merchant.id
        }
      }).then(function (response) {
        _this2.services = response.data.accounts;
        _this2.loading = false;
        _this2.fetch_dashboard_data(_this2.services);
        _this2.emitToBoard();
        _this2.fetch_gateway_sales({ merchant: _this2.selected_merchant.id, service_accounts: _this2.services.map(function (account) {
            return account.id;
          }) });
      }).catch(function (error) {
        _this2.loading = false;
      }).then(function () {
        _this2.loading = false;
      });
    },

    initialize_dashboard_data: async function initialize_dashboard_data() {
      try {
        var api_url = "/api/dashboard/admin/data";
        var payload = {
          merchant: null,
          service_accounts: []
        };
        this.loading = true;

        var response = await Vue.axios.post(api_url, payload);
        var content = response.data.content;

        this.merchants = content.merchants;
        this.default_currency = content.currency;

        this.daily_reg = content.daily_reg;
        this.monthly_reg = content.monthly_reg;
        this.annual_reg = content.annual_reg;
        this.all_time_reg = content.all_time_reg;

        this.revenue_last_7days = content.revenue_last_7days;
        this.revenue_last_14days = content.revenue_last_14days;
        this.revenue_last_30days = content.revenue_last_30days;
        this.board_data = content.service_leader_board;
        this.applications_per_gateway_data = content.gateway_sales;
        this.applications_per_gateway_encoded_data = content.encoded_gateway_sales;

        this.weekly_applications_customers = content.weekly_applications_customers;
        this.monthly_applications_customers = content.monthly_applications_customers;
        this.bi_weekly_applications_customers = content.bi_weekly_applications_customers;
        this.years = content.years;

        this.emitToBoard();
        this.set_dashboard_data(this.default_currency);
      } catch (error) {
        console.log("error ", error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    fetch_dashboard_data_by_account_id: function fetch_dashboard_data_by_account_id(value) {
      var accounts = [];
      if (value) {
        accounts.push(value);
      }
      this.fetch_dashboard_data(accounts);
    },

    fetch_merchants: function fetch_merchants() {
      var _this3 = this;

      var api_url = "/api/dashboard/admin/data";
      Vue.axios.get(api_url + "?merchants=true").then(function (response) {
        _this3.merchants = response.data.merchants;
      }).catch(function (error) {}).then(function () {});
    },
    fetch_service_leader_board: function fetch_service_leader_board(payload) {
      var _this4 = this;

      var api_url = "/api/dashboard/admin/data";
      var params = {
        merchant: payload.merchant,
        service_accounts: payload.service_accounts,
        leaderboard: true
      };
      Vue.axios.post(api_url, params).then(function (response) {
        _this4.board_data = response.data.service_leader_board;
      }).catch(function (error) {}).then(function () {});
    },

    fetch_gateway_sales: function fetch_gateway_sales(payload) {
      var _this5 = this;

      var api_url = "/api/dashboard/admin/data";
      var params = {
        merchant: payload.merchant,
        service_accounts: payload.service_accounts,
        gateway_sales: true
      };
      Vue.axios.post(api_url, params).then(function (response) {
        _this5.applications_per_gateway_data = response.data.content.gateway_sales;
        _this5.applications_per_gateway_encoded_data = response.data.content.encoded_gateway_sales;
        _this5.years = response.data.content.years;
        _this5.emitToBoard();
      }).catch(function (error) {}).then(function () {});
    },
    fetch_dashboard_data: function fetch_dashboard_data(accounts) {
      var _this6 = this;

      var api_url = "/api/dashboard/admin/data";
      this.loading = this.loadingalltime = true;
      var merchant_id = null;
      if (this.selected_merchant) {
        merchant_id = this.selected_merchant.id;
      }
      var payload = {
        merchant: merchant_id,
        service_accounts: accounts.map(function (account) {
          return account.id;
        })
      };

      Vue.axios.post(api_url, payload).then(function (response) {
        var content = response.data.content;
        _this6.default_currency = content.currency;

        _this6.daily_reg = content.daily_reg;
        _this6.monthly_reg = content.monthly_reg;
        _this6.annual_reg = content.annual_reg;
        _this6.all_time_reg = content.all_time_reg;
        _this6.hourly_revenue = content.hourly_revenue;
        _this6.daily_revenue = content.daily_revenue;
        _this6.monthly_revenue = content.monthly_revenue;
        _this6.annual_revenue = content.annual_revenue;
        _this6.revenue_last_7days = content.revenue_last_7days;
        _this6.revenue_last_14days = content.revenue_last_14days;
        _this6.revenue_last_30days = content.revenue_last_30days;

        _this6.weekly_applications_customers = content.revenue_last_7days;
        _this6.monthly_applications_customers = content.revenue_last_30days;
        _this6.bi_weekly_applications_customers = content.revenue_last_14days;

        _this6.set_dashboard_data(_this6.default_currency);
        _this6.fetch_gateway_sales(payload);
        _this6.fetch_service_leader_board(payload);
        _this6.emitToBoard();
      }).catch(function (error) {
        _this6.loading = false;
      }).then(function () {});
    },
    emitToBoard: function emitToBoard(event) {

      this.$emit("sycnmerchant", this.current_selection.id);
      this.$emit("syncaccount", [this.selected_service]);
      this.$emit("leaderboardservices", this.board_data);
      this.$emit("gatewaysales", this.applications_per_gateway_data);
      this.$emit("gatewaysalesencoded", this.applications_per_gateway_encoded_data);
      this.$emit("weeklyapplicationscustomers", this.weekly_applications_customers);
      this.$emit("biweeklyapplicationscustomers", this.bi_weekly_applications_customers);
      this.$emit("monthlyapplicationscustomers", this.monthly_applications_customers);
    },
    set_dashboard_data: function set_dashboard_data(dcurrency) {
      this.revenue_today = {
        invoices: this.to_human_no_fixed(this.dt_revenue_today.invoices),
        usd: "USD " + this.to_human(this.dt_revenue_today.usd),
        default_currency: dcurrency + " " + this.to_human(this.dt_revenue_today.default_currency),
        customers: this.to_human_no_fixed(this.dt_revenue_today.customers)
      };

      this.revenue_this_month = {
        invoices: this.to_human_no_fixed(this.dt_revenue_this_month.invoices),
        usd: "USD " + this.to_human(this.dt_revenue_this_month.usd),
        default_currency: dcurrency + " " + this.to_human(this.dt_revenue_this_month.default_currency),
        customers: this.to_human_no_fixed(this.dt_revenue_this_month.customers)
      };

      this.revenue_this_year = {
        invoices: this.to_human_no_fixed(this.dt_revenue_this_year.invoices),
        usd: "USD " + this.to_human(this.dt_revenue_this_year.usd),
        default_currency: dcurrency + " " + this.to_human(this.dt_revenue_this_year.default_currency),
        customers: this.to_human_no_fixed(this.dt_revenue_this_year.customers)
      };

      this.revenue_all_time = {
        invoices: this.to_human_no_fixed(this.dt_revenue_all_time.invoices),
        usd: "USD " + this.to_human(this.dt_revenue_all_time.usd),
        default_currency: dcurrency + " " + this.to_human(this.dt_revenue_all_time.default_currency),
        customers: this.to_human_no_fixed(this.dt_revenue_all_time.customers)
      };
      this.loadingalltime = this.loading = false;

      this.set_seven_day_revenue_chart();
      this.set_frtn_day_revenue_chart();
      this.set_thirty_day_revenue_chart();
      this.$emit("synccur", dcurrency);
    },
    to_human_no_fixed: function to_human_no_fixed(x) {
      if (x == null) return 0;
      return x.toLocaleString();
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    },
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    set_hourly_chart: function set_hourly_chart() {
      $("#hourly_chart").highcharts({
        chart: {
          renderTo: "hourly_chart",
          backgroundColor: null,
          borderWidth: 0,
          type: "areaspline",
          margin: [3, 0, 0, 0],
          height: 40,
          style: {
            overflow: "visible"
          },

          skipClone: true
        },
        title: {
          text: ""
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        xAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          alignTicks: false,
          minPadding: 0,
          maxPadding: 0
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          tickPositions: [0]
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 4,
            shadow: false,
            states: {
              hover: {
                enabled: false
              }
            },
            marker: {
              radius: 0
            }
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: this.hourly_revenue.map(function (e) {
            return e.usd;
          }).map(function (e) {
            return parseFloat(e);
          })
        }, {
          lineWidth: 2,
          color: "#3C009B",
          fillColor: {
            linearGradient: [0, 0, 0, 40],
            stops: [[0, "rgb(176,145,226)"], [1, "rgb(255, 255, 255)"]]
          },
          data: this.hourly_revenue.map(function (e) {
            return e.default_currency;
          }).map(function (e) {
            return parseFloat(e);
          })
        }]
      });
    },
    set_daily_chart: function set_daily_chart() {
      $("#daily_chart").highcharts({
        chart: {
          renderTo: "daily_chart",
          backgroundColor: null,
          borderWidth: 0,
          type: "areaspline",
          margin: [3, 0, 0, 0],
          height: 40,
          style: {
            overflow: "visible"
          },

          skipClone: true
        },
        title: {
          text: ""
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        xAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          alignTicks: false,
          minPadding: 0,
          maxPadding: 0
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          tickPositions: [0]
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 4,
            shadow: false,
            states: {
              hover: {
                enabled: false
              }
            },
            marker: {
              radius: 0
            }
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: this.daily_revenue.map(function (e) {
            return e.usd;
          }).map(function (e) {
            return parseFloat(e);
          })
        }, {
          lineWidth: 2,
          color: "#3C009B",
          fillColor: {
            linearGradient: [0, 0, 0, 40],
            stops: [[0, "rgb(176,145,226)"], [1, "rgb(255, 255, 255)"]]
          },
          data: this.daily_revenue.map(function (e) {
            return e.default_currency;
          }).map(function (e) {
            return parseFloat(e);
          })
        }]
      });
    },
    set_monthly_chart: function set_monthly_chart() {
      $("#monthly_chart").highcharts({
        chart: {
          renderTo: "monthly_chart",
          backgroundColor: null,
          borderWidth: 0,
          type: "areaspline",
          margin: [3, 0, 0, 0],
          height: 40,
          style: {
            overflow: "visible"
          },

          skipClone: true
        },
        title: {
          text: ""
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        xAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          alignTicks: false,
          minPadding: 0,
          maxPadding: 0
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          tickPositions: [0]
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 4,
            shadow: false,
            states: {
              hover: {
                enabled: false
              }
            },
            marker: {
              radius: 0
            }
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: this.monthly_revenue.map(function (e) {
            return e.usd;
          }).map(function (e) {
            return parseFloat(e);
          })
        }, {
          lineWidth: 2,
          color: "#E88018",
          fillColor: {
            linearGradient: [0, 0, 0, 40],
            stops: [[0, "rgb(254,215,179)"], [1, "rgb(255, 255, 255)"]]
          },
          data: this.monthly_revenue.map(function (e) {
            return e.default_currency;
          }).map(function (e) {
            return parseFloat(e);
          })
        }]
      });
    },
    set_annual_chart: function set_annual_chart() {
      $("#annual_chart").highcharts({
        chart: {
          renderTo: "annual_chart",
          backgroundColor: null,
          borderWidth: 0,
          type: "areaspline",
          margin: [3, 0, 0, 0],
          height: 40,
          style: {
            overflow: "visible"
          },

          skipClone: true
        },
        title: {
          text: ""
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        xAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          alignTicks: false,
          minPadding: 0,
          maxPadding: 0
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false
          },
          title: {
            text: null
          },

          tickPositions: [0]
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 4,
            shadow: false,
            states: {
              hover: {
                enabled: false
              }
            },
            marker: {
              radius: 0
            }
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: this.annual_revenue.map(function (e) {
            return e.usd;
          }).map(function (e) {
            return parseFloat(e);
          })
        }, {
          lineWidth: 2,
          color: "#9B0000",
          fillColor: {
            linearGradient: [0, 0, 0, 40],
            stops: [[0, "rgb(240,221,222)"], [1, "rgb(255, 255, 255)"]]
          },
          data: this.annual_revenue.map(function (e) {
            return e.default_currency;
          }).map(function (e) {
            return parseFloat(e);
          })
        }]
      });
    },
    set_seven_day_revenue_chart: function set_seven_day_revenue_chart() {
      var data = this.revenue_last_14days;
      try {
        data = data.sort(function (d1, d2) {
          var m1 = (0, _moment2.default)(d1.date);
          var m2 = (0, _moment2.default)(d2.date);
          if (m1.isBefore(m2)) return -1;
          if (m1.isSame(m2)) return 0;
          if (m1.isAfter(m2)) return 1;
        });
      } catch (e) {}

      var days = data.map(function (d) {
        return (0, _moment2.default)(d.day).format("ddd Do MMM");
      });
      var kes = data.map(function (d) {
        return parseFloat(d.default_currency);
      });
      var usd = data.map(function (d) {
        return parseFloat(d.usd);
      });

      $("#usd7").click(function () {
        $("#7day-revenue-area-graph .highcharts-legend-item:nth-child(1)").click();
        $(this).toggleClass("disabled");
      });
      $("#kes7").click(function () {
        $("#7day-revenue-area-graph .highcharts-legend-item:nth-child(2)").click();
        $(this).toggleClass("disabled");
      });

      var revenue7Day = new Highcharts.Chart({
        chart: {
          renderTo: "7day-revenue-area-graph",
          type: "area"
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ""
        },
        subtitle: {
          text: ""
        },
        xAxis: {
          gridLineWidth: 1,
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,
          align: "left",
          tickPositions: [0, 1, 2, 3, 4, 5, 6],
          tickmarkPlacement: "on",
          tickPosition: "inside",
          categories: days
        },
        yAxis: {
          gridLineWidth: 1,
          title: {
            text: ""
          }
        },
        tooltip: {
          formatter: function formatter() {
            return "<b>X</b>:" + this.x + "<br/>" + "<b>Y</b>:" + this.y;
          }
        },
        legend: {},
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: usd
        }, {
          lineWidth: 2,
          color: "#3C009B",
          name: this.default_currency + " Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(176,145,226)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: kes
        }]
      });
    },
    set_frtn_day_revenue_chart: function set_frtn_day_revenue_chart() {
      var data = this.revenue_last_14days;
      try {
        data = data.sort(function (d1, d2) {
          var m1 = (0, _moment2.default)(d1.date);
          var m2 = (0, _moment2.default)(d2.date);
          if (m1.isBefore(m2)) return -1;
          if (m1.isSame(m2)) return 0;
          if (m1.isAfter(m2)) return 1;
        });
      } catch (e) {}

      var days = data.map(function (d) {
        return d.day;
      });
      var kes = data.map(function (d) {
        return parseFloat(d.default_currency);
      });
      var usd = data.map(function (d) {
        return parseFloat(d.usd);
      });

      var dates = data.map(function (d) {
        return (0, _moment2.default)(d.day).format("ddd Do MMM");
      });

      $("#usd14").click(function () {
        $("#14day-revenue-area-graph .highcharts-legend-item:nth-child(1)").click();
        $(this).toggleClass("disabled");
      });
      $("#kes14").click(function () {
        $("#14day-revenue-area-graph .highcharts-legend-item:nth-child(2)").click();
        $(this).toggleClass("disabled");
      });

      var revenue14Day = new Highcharts.Chart({
        chart: {
          renderTo: "14day-revenue-area-graph",
          type: "area"
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ""
        },
        subtitle: {
          text: ""
        },
        xAxis: {
          gridLineWidth: 1,
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,
          align: "left",
          tickPositions: [].concat((0, _toConsumableArray3.default)(Array(dates.length).keys())),
          tickmarkPlacement: "on",
          tickPosition: "inside",
          categories: dates
        },
        yAxis: {
          gridLineWidth: 1,
          title: {
            text: ""
          }
        },
        tooltip: {
          formatter: function formatter() {
            return "<b>X</b>:" + this.x + "<br/>" + "<b>Y</b>:" + this.y;
          }
        },
        legend: {},
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: usd
        }, {
          lineWidth: 2,
          color: "#3C009B",
          name: this.default_currency + " Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(176,145,226)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: kes
        }]
      });
    },
    set_thirty_day_revenue_chart: function set_thirty_day_revenue_chart() {
      var data = this.revenue_last_30days;
      try {
        data = data.sort(function (d1, d2) {
          var m1 = (0, _moment2.default)(d1.date);
          var m2 = (0, _moment2.default)(d2.date);
          if (m1.isBefore(m2)) return -1;
          if (m1.isSame(m2)) return 0;
          if (m1.isAfter(m2)) return 1;
        });
      } catch (e) {}

      var dates = data.map(function (d) {
        return (0, _moment2.default)(d.day).format("ddd Do MMM");
      });
      var kes = data.map(function (d) {
        return parseFloat(d.default_currency);
      });
      var usd = data.map(function (d) {
        return parseFloat(d.usd);
      });

      $("#usd30").click(function () {
        $("#30day-revenue-area-graph .highcharts-legend-item:nth-child(1)").click();
        $(this).toggleClass("disabled");
      });
      $("#kes30").click(function () {
        $("#30day-revenue-area-graph .highcharts-legend-item:nth-child(2)").click();
        $(this).toggleClass("disabled");
      });

      var revenue30Day = new Highcharts.Chart({
        chart: {
          renderTo: "30day-revenue-area-graph",
          type: "area"
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ""
        },
        subtitle: {
          text: ""
        },
        xAxis: {
          gridLineWidth: 1,
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,
          align: "left",
          tickPositions: [].concat((0, _toConsumableArray3.default)(Array(dates.length).keys())),
          tickmarkPlacement: "on",
          tickPosition: "inside",
          categories: dates
        },
        yAxis: {
          gridLineWidth: 1,
          title: {
            text: ""
          }
        },
        tooltip: {
          formatter: function formatter() {
            return "<b>X</b>:" + this.x + "<br/>" + "<b>Y</b>:" + this.y;
          }
        },
        legend: {},
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: usd
        }, {
          lineWidth: 2,
          color: "#3C009B",
          name: this.default_currency + " Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(176,145,226)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: kes
        }]
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('withdrawal-tool',{attrs:{"conkey":_vm.con_key,"consecret":_vm.con_secret,"merchantid":_vm.merchant,"syncbal":_vm.current_account_balance,"currentaccountbalance":_vm.current_account_balance},on:{"update:syncbal":function($event){_vm.current_account_balance=$event}}}),_vm._v(" "),(_vm.loading)?_c('div',[_vm._m(0),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.admin)?_c('div',{staticClass:"card mt-4",staticStyle:{"background":"#fffef8"}},[_c('div',{staticClass:"card-body py-2"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-lg-4 order-lg-2"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid mt-md-n5 mt-lg-0 mr-md-n5",staticStyle:{"max-width":"397px"},attrs:{"src":_vm.banner,"alt":"..."}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 px-4 py-3 order-lg-1"},[_c('span',{staticClass:"h2 mb-0"},[_vm._v("Welcome back "+_vm._s(_vm.current_user))]),_vm._v(" "),_c('p',{staticClass:"mt-2 text-muted"},[_vm._v("Here’s how the numbers are looking.")]),_vm._v(" "),_c('hr')])])])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"stats"}},[(!_vm.admin)?_c('div',{staticClass:"card mt-4",staticStyle:{"background":"#fffef8"}},[_c('div',{staticClass:"card-body py-2"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-lg-4 order-lg-2"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid mt-md-n5 mt-lg-0 mr-md-n5",staticStyle:{"max-width":"397px"},attrs:{"src":_vm.banner,"alt":"..."}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 px-4 py-3 order-lg-1"},[_c('span',{staticClass:"h2 mb-0"},[_vm._v("Welcome back, "+_vm._s(_vm.current_user))]),_vm._v(" "),(_vm.current_account_balance > 0)?_c('p',{staticClass:"mt-2 text-muted"},[_vm._v("\n              Here’s how the numbers are looking.\n            ")]):_vm._e(),_vm._v(" "),(_vm.current_account_balance <= 0)?_c('p',{staticClass:"mt-2 text-muted"},[_vm._v("\n              Here’s how the numbers are looking.\n            ")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group mb-0 col-sm-6 border-right p-3"},[_c('label',[_vm._v("Filter by Merchant")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.merchants,"label":"name","value":_vm.current_selection},on:{"input":_vm.refresh_utility_accounts}}),_vm._v(" "),_c('span',{staticClass:"form-text"},[_vm._v("Start Typing the name of the merchant")])],1),_vm._v(" "),_c('div',{staticClass:"form-group mb-0 col-sm-6 p-3"},[_c('label',[_vm._v("Filter by Service")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.services,"label":"name"},on:{"input":_vm.fetch_dashboard_data_by_account_id},model:{value:(_vm.selected_service),callback:function ($$v) {_vm.selected_service=$$v},expression:"selected_service"}}),_vm._v(" "),_c('span',{staticClass:"form-text"},[_vm._v("Start Typing the name of the service")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"form-row margin-bottom-20"},[_c('div',{staticClass:"col-12 col-xl-3"},[_c('revenue-today',{attrs:{"synccur":_vm.default_currency,"merchant":_vm.current_selection,"sycnmerchant":_vm.current_selection,"syncaccount":_vm.selected_service},on:{"update:synccur":function($event){_vm.default_currency=$event},"update:sycnmerchant":function($event){_vm.current_selection=$event},"update:syncaccount":function($event){_vm.selected_service=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-3"},[_c('revenue-this-month',{attrs:{"synccur":_vm.default_currency,"merchant":_vm.current_selection,"sycnmerchant":_vm.current_selection,"syncaccount":_vm.selected_service},on:{"update:synccur":function($event){_vm.default_currency=$event},"update:sycnmerchant":function($event){_vm.current_selection=$event},"update:syncaccount":function($event){_vm.selected_service=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-3"},[_c('revenue-this-year',{attrs:{"synccur":_vm.default_currency,"merchant":_vm.current_selection,"sycnmerchant":_vm.current_selection,"syncaccount":_vm.selected_service},on:{"update:synccur":function($event){_vm.default_currency=$event},"update:sycnmerchant":function($event){_vm.current_selection=$event},"update:syncaccount":function($event){_vm.selected_service=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-3"},[_c('revenue-all-time',{attrs:{"synccur":_vm.default_currency,"merchant":_vm.current_selection,"sycnmerchant":_vm.current_selection,"syncaccount":_vm.selected_service},on:{"update:synccur":function($event){_vm.default_currency=$event},"update:sycnmerchant":function($event){_vm.current_selection=$event},"update:syncaccount":function($event){_vm.selected_service=$event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-row margin-bottom-20 mt-4"},[(_vm.can_view_account)?_c('div',{staticClass:"col-12 col-lg custom-col"},[_c('account-balance',{attrs:{"account_balances":_vm.account_balances.daily_balance,"can_view_account":_vm.can_view_account,"label":'Today ',"selected_merchant":_vm.current_selection ? _vm.current_selection.id : ''}})],1):_vm._e(),_vm._v(" "),(_vm.can_view_account)?_c('div',{staticClass:"col-12 col-lg custom-col"},[_c('account-balance',{attrs:{"account_balances":_vm.account_balances.today_balance,"can_view_account":_vm.can_view_account,"label":'Today',"selected_merchant":_vm.current_selection ? _vm.current_selection.id : ''}})],1):_vm._e(),_vm._v(" "),(_vm.can_view_account)?_c('div',{staticClass:"col-12 col-lg custom-col"},[_c('account-balance',{attrs:{"account_balances":_vm.account_balances.monthly_balance,"can_view_account":_vm.can_view_account,"label":'This Month',"selected_merchant":_vm.current_selection ? _vm.current_selection.id : ''}})],1):_vm._e(),_vm._v(" "),(_vm.can_view_account)?_c('div',{staticClass:"col-12 col-lg custom-col"},[_c('account-balance',{attrs:{"account_balances":_vm.account_balances.yearly_balance,"can_view_account":_vm.can_view_account,"label":'This Year',"selected_merchant":_vm.current_selection ? _vm.current_selection.id : ''}})],1):_vm._e(),_vm._v(" "),(_vm.can_view_account)?_c('div',{staticClass:"col-12 col-lg custom-col"},[_c('account-balance',{attrs:{"account_balances":_vm.account_balances.all_time_balance,"can_view_account":_vm.can_view_account,"label":'All Time',"selected_merchant":_vm.current_selection ? _vm.current_selection.id : ''}})],1):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card margin-bottom-20",attrs:{"id":"dashboard-revenue-card"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade active show",attrs:{"id":"revenue-last-7days","role":"tabpanel","aria-labelledby":"seven-days-view-tab"}},[_c('div',{staticClass:"form-row justify-content-end"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('button',{staticClass:"btn btn-sm btn-light ml-2",attrs:{"href":"","id":"usd7","type":"button"}},[_vm._v("\n                      USD Revenue\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-light ml-2",attrs:{"href":"","id":"kes7","type":"button"}},[_vm._v("\n                      "+_vm._s(_vm.default_currency)+" Revenue\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dropdown ml-2 d-inline"}),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"7day-revenue-area-graph"}})]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"revenue-last-14days","role":"tabpanel","aria-labelledby":"seven-days-view-tab"}},[_c('div',{staticClass:"form-row justify-content-end"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('button',{staticClass:"btn btn-sm btn-light ml-2",attrs:{"href":"","id":"usd14","type":"button"}},[_vm._v("\n                      USD Revenue\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-light ml-2",attrs:{"href":"","id":"kes14","type":"button"}},[_vm._v("\n                      "+_vm._s(_vm.default_currency)+" Revenue\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dropdown ml-2 d-inline"}),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"14day-revenue-area-graph"}})]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"revenue-last-30days","role":"tabpanel","aria-labelledby":"seven-days-view-tab"}},[_c('div',{staticClass:"form-row justify-content-end"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('button',{staticClass:"btn btn-sm btn-light ml-2",attrs:{"href":"","id":"usd30","type":"button"}},[_vm._v("\n                      USD Revenue\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-light ml-2",attrs:{"href":"","id":"kes30","type":"button"}},[_vm._v("\n                      "+_vm._s(_vm.default_currency)+" Revenue\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dropdown ml-2 d-inline"}),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"30day-revenue-area-graph"}})])])])])])]),_vm._v(" "),(_vm.admin)?_c('admin-applications-customer-revenue',{attrs:{"weeklyapplicationscustomers":_vm.weekly_applications_customers,"monthlyapplicationscustomers":_vm.monthly_applications_customers,"biweeklyapplicationscustomers":_vm.bi_weekly_applications_customers,"default_currency":_vm.default_currency,"current_merchant":_vm.current_selection,"current_service":_vm.selected_service,"dates":_vm.years,"merchant":_vm.selected_merchant,"service_accounts":_vm.selected_service},on:{"update:current_merchant":function($event){_vm.current_selection=$event},"update:current_service":function($event){_vm.selected_service=$event}}}):_vm._e(),_vm._v(" "),(_vm.admin)?_c('admin-applications-per-gateway',{attrs:{"default_currency":_vm.default_currency,"gatewaysales":_vm.applications_per_gateway_data,"gatewaysalesencoded":_vm.applications_per_gateway_encoded_data,"merchant":_vm.selected_merchant,"service_accounts":_vm.selected_service},on:{"update:gatewaysales":function($event){_vm.applications_per_gateway_data=$event},"update:gatewaysalesencoded":function($event){_vm.applications_per_gateway_encoded_data=$event}}}):_vm._e(),_vm._v(" "),(_vm.admin)?_c('admin-service-leader-board',{attrs:{"leaderboardservices":_vm.board_data},on:{"update:leaderboardservices":function($event){_vm.board_data=$event}}}):_vm._e(),_vm._v(" "),(_vm.can_view_account)?_c('admin-accounts',{key:_vm.current_selection ? _vm.current_selection.id : '',attrs:{"selected_service":_vm.selected_service ? _vm.selected_service.id : '',"selected_merchant":_vm.current_selection ? _vm.current_selection.id : ''}}):_vm._e()],1)],1)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"spinner-border"}),_vm._v("\n        \n      "),_c('span',[_vm._v("Please wait, loading dashboard ...")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-auto align-middle"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header tbn-tabs justify-content-end"},[_c('div',{staticClass:"col-md-3 nav -nav-tabs btn-group btn-group-toggle",attrs:{"role":"tablist","data-toggle":"buttons"}},[_c('a',{staticClass:"btn btn-sm btn-light border border-secondary active",attrs:{"href":"#revenue-last-7days","data-toggle":"tab","role":"tab"}},[_vm._v("7 days")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-light border border-secondary",attrs:{"href":"#revenue-last-14days","data-toggle":"tab","role":"tab"}},[_vm._v("14 days")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-light border border-secondary",attrs:{"href":"#revenue-last-30days","data-toggle":"tab","role":"tab"}},[_vm._v("30 days")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-8"},[_c('h4',[_vm._v("Revenue - Last 7 Days")]),_vm._v(" "),_c('p',{staticClass:"subtitle",attrs:{"id":"7day-title"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown ml-2 d-inline"},[_c('div',{staticClass:"rw-btn rw-btn--card rw-btn--lg d-inline",attrs:{"data-toggle":"dropdown"}},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"update"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"expand"}},[_vm._v("Expand")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"invert"}},[_vm._v("Invert style")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"remove"}},[_vm._v("Remove card")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-8"},[_c('h4',[_vm._v("Revenue - Last 14 Days")]),_vm._v(" "),_c('p',{staticClass:"subtitle",attrs:{"id":"14day-title"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown ml-2 d-inline"},[_c('div',{staticClass:"rw-btn rw-btn--card rw-btn--lg d-inline",attrs:{"data-toggle":"dropdown"}},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"update"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"expand"}},[_vm._v("Expand")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"invert"}},[_vm._v("Invert style")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"remove"}},[_vm._v("Remove card")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-8"},[_c('h4',[_vm._v("Revenue - Last 30 Days")]),_vm._v(" "),_c('p',{staticClass:"subtitle",attrs:{"id":"30day-title"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown ml-2 d-inline"},[_c('div',{staticClass:"rw-btn rw-btn--card rw-btn--lg d-inline",attrs:{"data-toggle":"dropdown"}},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"update"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"expand"}},[_vm._v("Expand")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"invert"}},[_vm._v("Invert style")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","data-demo-action":"remove"}},[_vm._v("Remove card")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30eba986", __vue__options__)
  } else {
    hotAPI.reload("data-v-30eba986", __vue__options__)
  }
})()}